export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7397.0b67890f.jpg";